import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PersonIcon from '@material-ui/icons/Person';

import useTimeline from '../../timeline/useTimeline';
import { updateTreatmentInstance } from '../../../../actions/entities';
import { getVisibleOrgUnits } from '../../../../actions/areas/planner';
import { DropdownFilter } from '../../../Planner/Filters/DropdownFilter';
import { selectionTypes } from '../../../../enums/treatmentSelectionType';
import { getDateForApi } from '../../../../utils/dates';

export default function ChangeTreatmentUnit({ treatmentDetails, toggleRefresh, includeTreatments }) {
  const [orgUnit, setOrgUnit] = useState(null);
  const [availbaleOrgUnits, setAvailableOrgUnits] = useState([]);

  const dispatch = useDispatch();

  const {
    activeUnassignedTreatmentForChangeUnit,
    setActiveUnassignedTreatmentForChangeUnit,
    refreshClinicianTreatmentsAndClosePanels,
    getAccessToken,
  } = useTimeline();

  useEffect(() => {
    getVisibleOrgUnits(
      getAccessToken,
      { RelevantDay: getDateForApi(treatmentDetails.treatmentInstance.occurrence) },
      false,
      response => {
        setAvailableOrgUnits(response);
      },
    );
  }, []);

  const selectionType = () => {
    if (treatmentDetails.treatment.isSpecific) return selectionTypes.specific;
    if (treatmentDetails.treatment.isMultiple) return selectionTypes.multiple;
    return selectionTypes.timeSlot;
  };

  const recheduleUnassignedTreatmentInstance = () => {
    let updatedTreatment = {};
    const treatmentInstance = treatmentDetails.treatmentInstance;
    if (selectionType() === selectionTypes.specific) {
      updatedTreatment = {
        treatmentId: treatmentInstance.treatmentId,
        treatmentInstanceId: treatmentInstance.treatmentInstanceId,
        isSpecific: true,
        occurenceOriginalDate: getDateForApi(treatmentInstance.occurrence),
        specificTimeFrom: getDateForApi(treatmentInstance.effectiveTimeSlots[0].from),
      };
    } else {
      updatedTreatment = {
        treatmentId: treatmentInstance.treatmentId,
        treatmentInstanceId: treatmentInstance.treatmentInstanceId,
        isSpecific: false,
        occurenceOriginalDate: getDateForApi(treatmentInstance.occurrence),
        timeSlotsMatrix: treatmentInstance.selectedTimeSlots,
        timeSlotPackageId: treatmentInstance.timeSlotPackage.id,
      };
    }
    updatedTreatment.orgUnitIds = [orgUnit];
    dispatch(updateTreatmentInstance(updatedTreatment)).then(() => {
      refreshClinicianTreatmentsAndClosePanels();
      if (includeTreatments) toggleRefresh();
    });
  };

  const headerInfo = () => {
    return (
      <div className="grey-sidePanel-header">
        <div className="sidePanel-header-subtitle">
          <Box flexGrow={1} py={1}>
            <Typography variant="subtitle1">Change unit</Typography>
          </Box>
        </div>
        <div className="sidePanel-header-title-wrap">
          <div className="sidePanel-header-title">
            <Typography variant="h2">{activeUnassignedTreatmentForChangeUnit.patientName}</Typography>
            <Typography variant="h3" gutterBottom>
              {activeUnassignedTreatmentForChangeUnit.postcode}
            </Typography>
            <Typography variant="h5">{activeUnassignedTreatmentForChangeUnit.band}</Typography>
          </div>
          <div className="sidePanel-header-info">
            <div className="sidePanel-header-info patient-header">
              <List component="nav">
                <div className="patient-info-details">
                  <ListItem key={'required-people'}>
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary={activeUnassignedTreatmentForChangeUnit.numberOfClinicians} />
                  </ListItem>
                </div>
              </List>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const mainContent = () => {
    return (
      <div className="reschedule-sidePanel-form">
        <Box mb={1}>
          <Typography variant="h6" gutterBottom>
            Current unit:
          </Typography>
          <p>{treatmentDetails.treatmentInstance.orgUnit.name}</p>
        </Box>
        <Box mb={2}>
          <Typography variant="h6" gutterBottom>
            Select a unit
          </Typography>
          <Box py={1}>
            <DropdownFilter
              dropdownId="changeOrgUnit"
              fullWidth
              label="Standard"
              data={availbaleOrgUnits}
              filterKey={'orgUnit'}
              filterValue={orgUnit}
              onChange={(name, value) => setOrgUnit(value)}
            />
          </Box>
        </Box>
      </div>
    );
  };

  const actionButtons = () => {
    return (
      <div className="sidePanel-footer">
        <div className="sidePanel-buttons">
          <div className="sidePanel-BackButton">
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setActiveUnassignedTreatmentForChangeUnit(null);
              }}
            >
              Back
            </Button>
          </div>
          <div className="sidePanel-saveButton">
            <Button
              variant="contained"
              color="primary"
              disabled={!orgUnit}
              onClick={recheduleUnassignedTreatmentInstance}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer
        anchor="right"
        open={activeUnassignedTreatmentForChangeUnit !== null}
        onOpen={() => {}}
        onClose={() => setActiveUnassignedTreatmentForChangeUnit(null)}
        id="lala"
      >
        <div className="sidePanel-wrapper" style={{ width: '350px' }} id="change-unit-side-panel">
          {headerInfo()}
          {mainContent()}
          {actionButtons()}
        </div>
      </SwipeableDrawer>
    </section>
  );
}
